import React from 'react';
import { FileVersionsModal } from './FileVersionsModal';
import { useStudyFileVersions } from '@/services/studyFilesHooks';
import { StudyFile, StudyFileVersion } from '@/types/studyFiles';
import { getStudyFileVersionDownloadEndpoint } from '@/utils/downloadEndpoints';

interface StudyFileVersionsModalProps {
  file: StudyFile | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Wrapper component for StudyFile version history modal
 * Uses generic FileVersionsModal with StudyFile-specific configuration
 */
const StudyFileVersionsModal: React.FC<StudyFileVersionsModalProps> = ({
  file,
  open,
  onOpenChange,
}) => {
  return (
    <FileVersionsModal<StudyFile, StudyFileVersion>
      file={file}
      open={open}
      onOpenChange={onOpenChange}
      useVersionsHook={useStudyFileVersions}
      getDownloadEndpoint={getStudyFileVersionDownloadEndpoint}
      modalTitle="Version History"
      modalSize="medium"
      showExtensionColumn={true}
    />
  );
};

export default StudyFileVersionsModal;
